import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const hashtag = [
  'REVIERA OMELETTE',
  'NEW YORK STEAK&EGGS',
  'CRISPY BACON WAFFLE OR BACON PANCAKES',
];

export const HashtagTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Raleway',
  fontSize: '15px',
  fontWeight: '400',
  lineHeight: '18px',
  color: '#FFFFFF',
  maxWidth: 'calc(100% - 40px)',
  margin: '70px auto 0',
  [theme.breakpoints.down('sm')]: {
    margin: '39px auto 0',
  },
}));

export default function TrendingHashtag() {
  return (
    <HashtagTypography>
      Trending
      {hashtag.map((trending, index) => {
        return <span key={index}>#{trending}</span>;
      })}
    </HashtagTypography>
  );
}
